import React, {   useRef,useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom';  
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';   
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css";
import "css/customDialog.css";   
import MenuItem  from "@mui/material/MenuItem"; 
import SendIcon from '@mui/icons-material/Send'; 
import Textarea from '@mui/joy/Textarea';
import { TextField } from '@mui/material';
import ReportTicketsSendEmail from "pages/ticketsDetails/ticketsSentEmail/ReportTicketsSendEmail";
import PropTypes from 'prop-types';  

const initialStateTicketsSendEmail = {
  id : "",
  defaultStore_id:0, 
  tradename: "",
  useraccount_id:0,
  username: "",
  defaultformatnumber:1,
  isfinished:false, 
  numberticket:0, 
  purchasenote:0, 
  ownnumbertickes:0, 
  start_date_ticket: "",
  end_date_ticket: "", 
  vehiclestore_id: 0,
  vehiclestore_licenseplate: "",
  vehiclestore_tara: 0,
  vehiclestore_pma: 0,
  vehiclestore_checkpma: true,
  vehiclestore_defaultdriver: "",
  vehiclestore_store_id: 0,
  rel_trans_store_id: 0,
  rel_trans_documnettype_id: 0,
  rel_trans_documentid: "",
  rel_trans_documnettype_name: "",
  rel_trans_tradename: "",
  rel_trans_name: "",
  rel_trans_contacperson: "",
  rel_trans_roadtype_id: 0,
  rel_trans_street: "",
  rel_trans_country_id: 1,
  rel_trans_province_id: 30,
  rel_trans_postalcode_id: 0,
  rel_trans_grnp:"",
  ori_tras_store_id: 0,
  ori_tras_documnettype_id: 0,
  ori_tras_documnettype_name: "",
  ori_tras_documentid: "",
  ori_tras_tradename: "",
  ori_tras_name: "",
  ori_tras_contacperson: "",
  ori_tras_roadtype_id: 0,
  ori_tras_street: "",
  ori_tras_country_id: 1,
  ori_tras_province_id: 30,
  ori_tras_postalcode_id: 0,
  observations: "",
  totalstartweight: 0,
  totalendweight: 0,
  newweightreading:0,
  enabled:true,
  linestickets:[],
  linesticketsWithOutWeight:[]
}; 

const initialStateEMAIL = {
  "id":"",
  "defaultStore_id":0, 
  "useraccount_id":0,
  "store_EmailTo":"",
  "subjectEmail":"",
  "contentEmail":"",
  "filetosend":[] 
}; 

const initialEmailToSelect = [{
  "id": "",
  "email": "" 
}];

const TicketsSendEmail = ({id, showModalTicketsSendEmail}) => {
  const {t,i18n} = useTranslation(['listDataTickets']);
  const token = useSelector((state) => state.loginUser.token);   
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const footeremail = useSelector((state) => state.loginUser.defaultticketsformat.footeremail);
   const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const [dataTickets, setDataTickets] = useState(initialStateTicketsSendEmail);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [formEMAIL, setFormEMAIL] = useState(initialStateEMAIL);
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const [pdfBlob, setPdfBlob] = useState(null); 
  const [emailToSelect,setEmailToSelect]= useState(initialEmailToSelect);  
  const [filteredEmail, setFilteredEmail] = useState([]); // Opciones filtradas
  const [highlightedIndexEmail, setHighlightedIndexEmail] = useState(-1); // Índice de la opción resaltada 
   
  const PdfViewer = useMemo(() => {
    return pdfBlob ? (
      <iframe
        src={URL.createObjectURL(pdfBlob)}
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    ) : null;
  }, [pdfBlob]);

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalTicketsSendEmail) {
        setDataTickets(dataTickets => ({
          ...dataTickets,
          linespurchasedelivery: [],
        }));
        setDataTickets(initialStateTicketsSendEmail);
        dispatch(setLoading(false));  
        setPdfBlob(null); 
        setFormEMAIL(initialStateEMAIL);
        setErrorsEMAIL({});
        setEmailToSelect(initialEmailToSelect);
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1);  
        navigate("/ticketsdetails");
      }
    },
    [
      setDataTickets,  
      setPdfBlob,    
      showModalTicketsSendEmail,
      setEmailToSelect,
      setFilteredEmail,
      setHighlightedIndexEmail, 
      dispatch,
      navigate]
  );
  
  const handleCloseSendEmailTickets = () => {
    setDataTickets(dataTickets => ({
      ...dataTickets,
      linespurchasedelivery: [],
    }));
    setDataTickets(initialStateTicketsSendEmail);
    dispatch(setLoading(false));
    setPdfBlob(null);   
    setFormEMAIL(initialStateEMAIL);
    setErrorsEMAIL({});
    setEmailToSelect(initialEmailToSelect);
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1); 
    navigate("/ticketsdetails"); 
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchEmail= useDebounce((searchValue) => {
    const upperValue = searchValue.toLowerCase();
    if (upperValue.trim() === "") {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
      return;
    }
    const filtered = emailToSelect
        .filter(store => store && store.email)
        .filter(store => {
        const emails = store.email.toLowerCase();
        return emails.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
      setFilteredEmail(filtered);
      setHighlightedIndexEmail(0);
  }, 300);  
  const handleSelectEmail = (email) => {
    if (!email) return; // Validación adicional para evitar errores
    setFormEMAIL((formEMAIL) => ({
      ...formEMAIL,
      store_EmailTo: email.email || ""
      
    }));
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
  }; 

  const handleKeyDownEmail = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredEmail.length === 0 && formEMAIL.store_EmailTo.trim() === "") {
        setFilteredEmail(emailToSelect);
        setHighlightedIndexEmail(0);
      } else {
        setHighlightedIndexEmail((prevIndex) => {
          const nextIndex = prevIndex < filteredEmail.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexEmail((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexEmail >= 0) {
      if (highlightedIndexEmail >= 0 && highlightedIndexEmail < filteredEmail.length) {
        handleSelectEmail(filteredEmail[highlightedIndexEmail]);
      }
    } else if (event.key === "Escape") {
      const isValid = emailToSelect.some((email) => {
        if (!email || !email.workplace) return false; 
        const normalizedEmail = email.email.toLowerCase();
        const normalizedInputEmail = formEMAIL.store_EmailTo.toLowerCase();
        return normalizedEmail === normalizedInputEmail;
      }); 
      if (!isValid) {
        setFormEMAIL((formEMAIL) => ({
          ...formEMAIL,
          store_EmailTo: "",
        }));
      } 
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  };

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
   const handleBlur = useCallback((event) => {
       if (!event || !event.currentTarget) return;
       // Asegúrate de que no se cierra si haces clic en un elemento de la lista
       if (!event.currentTarget.contains(event.relatedTarget)) {
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1);
      }
    }, []);
    

  const handleBlurDataEditEmail = (e) => {
    handleChangeDataEditEmail(e);
    setErrorsEMAIL(validateFormEmail());
  };

  const handleChangeDataEditEmail = (e) => {
    const { name, value } = e.target;
    setFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      [name]: value,
    })); 
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob); // ✅ Convierte el Blob a Base64
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // ✅ Remueve "data:application/pdf;base64,"
      reader.onerror = reject;
    });
  };

  const validateFormEmail = () => {
    let errorsEMAIL = {};
    //let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (!formEMAIL.store_EmailTo || formEMAIL.store_EmailTo==="") {
      errorsEMAIL.store_EmailTo = 'Text_FieldSendEmailToRequired'; 
    } else {
      if (regexInvalidCharacters.test(formEMAIL.store_EmailTo)) {
        errorsEMAIL.store_EmailTo = 'Text_TextNoValid';
      }
    }  

    if (regexInvalidCharacters.test(formEMAIL.subjectEmail)) {
      errorsEMAIL.subjectEmail = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(formEMAIL.contentEmail)) {
      errorsEMAIL.contentEmail = 'Text_TextNoValid';
    }  
    return errorsEMAIL;
  };

  const handleSubmitSendEmail =  async ()=>{
    const errors = validateFormEmail();
    setErrorsEMAIL(errors); 
    if (
      Object.keys(errors).length === 0 &&
      formEMAIL &&
      formEMAIL.store_EmailTo &&
      formEMAIL.store_EmailTo !== "" &&
      pdfBlob
    ) {  
      dispatch(setLoading(true));
      // ✅ Convertir Blob a Base64 sin detener la ejecución
      blobToBase64(pdfBlob)
      .then((base64File) => {
        const formData = {
          id: id,
          defaultStore_id: defaultStore.id,
          useraccount_id: useraccount_id,
          store_EmailTo: formEMAIL.store_EmailTo,
          subjectEmail: formEMAIL.subjectEmail,
          contentEmail: formEMAIL.contentEmail,
          filetosend: base64File, 
          fileName: `Ticket_${id.toString().padStart(8, '0')}.pdf`,
          fileType: "application/pdf",
        }; 
        // ✅ Llamada asíncrona sin bloquear el flujo 
        fetchData(formData);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }); 
      const fetchData = async (formData) => {
        try {
          const getData = await helpHttp().postemail(ENDPOINT, `api/sendemailwithattachment`, token,formData);
            if (getData.status === "OK") {
                dispatch(setLoading(false));
                dispatch(successErrorAction(t('Text_SaveData')));
              } else { 
                dispatch(setLoading(false));
                dispatch(warningErrorAction(t(getData.cause))); 
              }
            } catch (error) {
              dispatch(setLoading(false));
              dispatch(warningErrorAction(t('Text_IncorrectData')));
            } finally { 
              dispatch(setLoading(false));
              handleCloseSendEmailTickets();
            }
        return () => { };
      };
      //fetchData();
    } else { 
      if (errorsEMAIL.store_EmailTo) {
        dispatch(warningErrorAction(t(errorsEMAIL.store_EmailTo)));
      } else if (errorsEMAIL.subjectEmail) {
        dispatch(warningErrorAction(t(errorsEMAIL.subjectEmail)));
      } else if (errorsEMAIL.contentEmail) {
        dispatch(warningErrorAction(t(errorsEMAIL.contentEmail)));
      } else if (!pdfBlob) {
        dispatch(warningErrorAction(t('Text_FieldSendFileRequired')));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };  
 useEffect(() => {
    let isMounted = true; 
    const fetchDataEmail = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`api/getlistemails/`,token,
          (formEMAIL.store_EmailTo!==undefined && formEMAIL.store_EmailTo!==null && formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim()!=="")?formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setEmailToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    if (showModalTicketsSendEmail && formEMAIL.store_EmailTo && formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim()!=="") { 
      fetchDataEmail();
    }else{
      setEmailToSelect(initialEmailToSelect);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,showModalTicketsSendEmail,formEMAIL.store_EmailTo]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (pdfBlob) {
      const formatted_id = id.toString().padStart(8, '0');
      const file = new File([pdfBlob], "Ticket_"+formatted_id+".pdf", { type: "application/pdf" });
      setFormEMAIL((formEMAIL) => ({
        ...formEMAIL,
        filetosend: file // Se almacena directamente como un único archivo
      }));
    }
  }, [pdfBlob,id]);   

  useEffect(() => {
    let isMounted = true;
    const fetchDataTcikets = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`ticketsdetails/getticketbyid/`,token,id);
        if (getData.err) {
          setDataTickets(initialStateTicketsSendEmail); 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataTickets(getData);
          setFormEMAIL(formEMAIL => ({
            ...formEMAIL,
            defaultStore_id:defaultStore.id,
            useraccount_id:useraccount_id,
            store_EmailTo: getData.ori_tras_email,
            subjectEmail:"LE REMITO EL TCIKET Nº: "+getData.numberticket,
            contentEmail:footeremail
          })); 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    if (id!=="0"){
      if (dataTickets.id===""){
        fetchDataTcikets(); 
        dispatch(setLoading(false));
      }
    }else{
      setDataTickets(initialStateTicketsSendEmail);
      setDataTickets(dataTickets => ({
        ...dataTickets,
        linespurchasedelivery:[]
      }));
      setFormEMAIL(formEMAIL => ({
        ...formEMAIL,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        contentEmail:footeremail
      })); 
      dispatch(setLoading(false));
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,pdfBlob,dataTickets.id,defaultStore.id,useraccount_id,footeremail]);  

  return (
    <>
      {showModalTicketsSendEmail ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '1050px'}}>
            <form onSubmit={handleCloseSendEmailTickets}>
              {/* HEADER */}
              <div className="email-card-header">
                <div className="email-header-content">
                  <div className="email-header-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="email-header-text">
                    <div className="email-header-title">
                      {t('Text_NumberTickets_EMAIL')}:
                    </div>
                    <div className="email-header-number">
                      {dataTickets.numberticket}
                    </div>
                  </div>
                  <div className="email-card-actions">
                    {!isLoadingData && (
                      <>
                        <button type="button" className="email-send-btn" onClick={handleSubmitSendEmail} >
                          {t('Button_SEND')}
                          <SendIcon sx={{ fontSize: 22, color: "white" }} />
                        </button>
                        <button type="button" className="email-cancel-btn" onClick={handleCloseSendEmailTickets} >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>  
              {/* FORM CARD */}
              {!isLoadingData ?
                <>
                  <div className="email-card-form">
                    <div className="row g-3">
                      {/* Email To */}
                      <div className="col-12 email-input" style={{ position: 'relative' }}>
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_EmailsTo')} :
                        </label>
                        <TextField
                          id="store_EmailTo"
                          name="store_EmailTo"
                          value={formEMAIL.store_EmailTo}
                          onChange={(e) => {
                            setFormEMAIL(prev => ({ ...prev, store_EmailTo: e.target.value.toLowerCase() }));
                            debouncedHandleSearchEmail(e.target.value);
                          }}
                          onKeyDown={handleKeyDownEmail}
                          onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".email-suggest-dropdown")) {
                              handleBlur();
                            }
                          }}
                          label={
                            errorsEMAIL.store_EmailTo != null
                              ? t(errorsEMAIL.store_EmailTo)
                              : t('PlaceHolder_SENDEMAIL_EmailsTo')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_EmailsTo')}
                          variant="standard"
                          inputProps={{ style: { width: i18n.language === 'es' ? 738 : 867 } , maxLength: 100 }}
                          InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                        />

                        {filteredEmail.length > 0 && (
                          <div className="email-suggest-dropdown" onMouseDown={(e) => e.preventDefault()}>
                            {filteredEmail.map((store, index) => (
                              <MenuItem
                                key={store.id}
                                onClick={() => handleSelectEmail(store)}
                                style={{
                                  cursor: "pointer",
                                  padding: "10px 12px",
                                  borderBottom: "1px solid #eee",
                                  fontSize: 18,
                                  backgroundColor: index === highlightedIndexEmail ? "#4e73df" : "transparent",
                                  color: index === highlightedIndexEmail ? "white" : "black",
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                {store.email}
                              </MenuItem>
                            ))}
                          </div>
                        )}
                      </div>
                      {/* Subject */}
                      <div className="col-12 email-input">
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_Subject')}
                        </label>
                        <TextField
                          id="subjectEmail"
                          name="subjectEmail"
                          value={formEMAIL.subjectEmail ?? ""}
                          inputProps={{ style: { width: i18n.language === "es" ? 941 : 937 }, maxLength: 100 }}
                          InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                          label={
                            errorsEMAIL.subjectEmail != null
                              ? t(errorsEMAIL.subjectEmail)
                              : t('PlaceHolder_SENDEMAIL_Subject')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_Subject')}
                          variant="standard"
                          onBlur={handleBlurDataEditEmail}
                          onChange={handleChangeDataEditEmail}
                        />
                      </div>
                       
                       {/* Content */}
                        <div className="col-12">
                          <label className="text-primary" style={{ fontSize: 18 }}>
                            {t('Text_SENDEMAIL_Content')} :
                          </label>
                          <Textarea
                            id="contentEmail"
                            name="contentEmail"
                            value={formEMAIL.contentEmail}
                            className="email-textarea"
                            label={
                              errorsEMAIL.contentEmail != null
                                ? t(errorsEMAIL.contentEmail)
                                : t('PlaceHolder_SENDEMAIL_Content')
                            }
                            placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                            sx={{ width: 1000, fontSize: 18 }}
                            variant="standard"
                            onBlur={handleBlurDataEditEmail}
                            onChange={handleChangeDataEditEmail}
                            maxRows={8}
                          />
                        </div> 
                    </div>   
                  </div>   
                  {/* PDF CARD */}
                  <div className="email-card-pdf">
                    {PdfViewer}
                  </div>
                </>:
                  <LoadingNews/>
                } 
              </form>
            </Box>
            <ReportTicketsSendEmail 
              dataTickets={dataTickets}  
              setPdfBlob={setPdfBlob} 
            />
            <br/>
          </div>
        //* End Page Content *//
      ) :  null }
    </>
  )    
}

TicketsSendEmail.propTypes = {
  id: PropTypes.string.isRequired,
  showModalTicketsSendEmail: PropTypes.bool.isRequired
};

export default TicketsSendEmail;